export const pickClientCode = (
  readAccessClientCodes: string[],
  lastClientCode: string | null,
  commonClientCode: string,
  requestedClientCode?: string,
): string | null => {
  const availableClientCodes = (readAccessClientCodes ?? []).filter((clientCode): clientCode is string => !!clientCode);

  if (availableClientCodes.length === 0) {
    return null;
  }

  if (requestedClientCode && availableClientCodes.includes(requestedClientCode)) {
    return requestedClientCode;
  }

  if (lastClientCode && availableClientCodes.includes(lastClientCode)) {
    return lastClientCode;
  }

  return availableClientCodes.find((clientCode) => clientCode !== commonClientCode) ?? availableClientCodes[0];
};
